import styled from 'styled-components';
import { TopProject } from '../../types/globalTypes';
import { UpdatesItem } from './UpdatesItem';
import { TUpdatesVisualMode } from './Updates';
import { Text } from '../Text/Text';
import { COLORS, FONTS } from '../../constants';
import { useMemo } from 'react';
import { groupProjectsByDate } from '../../utils/groupProjectsByDate';

interface UpdatesDateListProps {
  newProjectsList: TopProject[];
  visualMode: TUpdatesVisualMode;
  onLinkClick?: () => void;
}

export const UpdatesDateList = ({
  newProjectsList,
  visualMode,
  onLinkClick,
}: UpdatesDateListProps) => {
  const { groupedProjects, sortedDates } = useMemo(() => {
    return groupProjectsByDate(newProjectsList);
  }, [newProjectsList]);

  return (
    <ListContainer>
      {sortedDates.map(date => (
        <DateSection key={date}>
          <Text
            text={date}
            fontFamily={FONTS.SUBTITLE}
            size={12}
            lineHeight={20}
            color={COLORS.GRAY_TEXT}
          />
          <ProjectsList>
            {groupedProjects[date].map((project, index) => (
              <UpdatesItem
                key={`${date}-${index}`}
                name={project.Name}
                visualMode={visualMode}
                onLinkClick={onLinkClick}
              />
            ))}
          </ProjectsList>
        </DateSection>
      ))}
    </ListContainer>
  );
};

const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 35px;
`;

const DateSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ProjectsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
